// extracted by mini-css-extract-plugin
export default {"Skeleton":"styles_Skeleton__Xr5Jm","shine":"styles_shine__eoKcT"};